import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ConnexionService {

	constructor(
	) { }

	public isOnline(): Observable<boolean> {
		// return of(false);
		

		return merge(
			of(navigator.onLine),
			fromEvent(window, 'online').pipe(map(() => true)),
			fromEvent(window, 'offline').pipe(map(() => false))
		);
	}
}